export const QUERY_CONFIG = {
  queries: {
    retry: 0,
    cacheTime: 0, // It's a CMS. No need in global caching because everything should be fresh in case someone edited in same moment
    queryFnParamsFilter: (args) => args.slice(1),
    /**
     * If you want to set refetchOnMount to true on queries keep in mind that all components which are dependent
     * and have this query with same key mounted will be refetched. Consider this example, the behaviour is not really
     * obvious and can lead to unexpected bugs. Real bug https://jira7.haynet.com:8443/browse/WACMSV2-392.
     *
     * We have a page with some id. We open details page.
     * We have have 1 instance of query with key ['page', { key: 'some-id' }].
     * We then add a new content module, like useful links.
     * Add a new link which points to the page we are currently editing.
     * Then the preview item is being rendered. It creates another instance of query with the
     * same id ['page', { key: 'some-id' }] to show a url using slug from fetched page.
     * Next will happen:
     * mounting that query instance in item preview will cause to refetch that query. Since refetchOnMount
     * is set to true even on that particular query, then query instance that is used in page detailed component
     * would go through fetch too by setting isLoading to true, statuses, etc. making the page to reload and loosing
     * all progress, because we show loading indicator when query is fetched unmounting the form component.
     *
     * I'm not really sure what are the cases when it needs to refetch query on mount forcing to refetch all
     * other queries that are mounted so I'm disabling it globally. Maybe on info sites there are some, but in
     * CMS I can't imagine any.
     *
     * If there is some case for this you should explicitly set it in query when you're calling it keeping in mind
     * behaviour described above. Or better way is to add additional parameter to key. For existing queries always
     * go with second option.
     *
     * In example above it will be something like additional keys array which will be spreaded in query key
     * and/or object with parameters

        const usePage = ({ id }, { additionalKeys = [], additionalParameters = {}, ...queryConfig }) => {
          const queryResult = useQuery(['page', ...castArray(additionalKeys), { id, ...additionalParameters }])
          ...
        }
        // call it
        usePage({ id: 'some-id' }, { additionalKeys: 'preview' })
        usePage({ id: 'some-id' }, { additionalKeys: ['preview', 'more'] })
        usePage({ id: 'some-id' }, { additionalParameters: { preview: true } })

     * or some boolean flag in query config

        const usePage = ({ id }, { isPreview = false, ...queryConfig }) => {
          const queryResult = useQuery(['page', { id, isPreview }]
          ...
        }
        // call it
        usePage({ id: 'some-id' }, { isPreview: true })
     */
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  },
};
